import { createStore } from 'vuex'
import CryptoJS from 'crypto-js'

// 使用較安全的密鑰生成方式
const SECRET_KEY = process.env.VUE_APP_SECRET_KEY || 'default-secret-key-for-development'

// 加密函數
const encrypt = (data) => {
  return CryptoJS.AES.encrypt(JSON.stringify(data), SECRET_KEY).toString()
}

// 解密函數
const decrypt = (ciphertext) => {
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, SECRET_KEY)
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8))
  } catch (error) {
    return null
  }
}

export default createStore({
  state: {
    token: null,
    roleId: null,
    account: null,
    // 特殊帳號權限配置
    permissionConfig: {
      'fenderdog9482@gmail.com': {
        extraMenus: ['checkEmployee', 'annualCheck', 'annualMonthCheck', 'annualYearCheck', 'mailSender'],
        roleOverride: 1,
        isSpecialAdmin: true
      },
      'kc.wu@sunsoft.space': {
        extraMenus: ['checkEmployee', 'annualCheck', 'annualMonthCheck', 'annualYearCheck', 'mailSender'],
        roleOverride: 1,
        isSpecialAdmin: true
      },
      'joey@sunsoft.space': {
        extraMenus: ['checkEmployee', 'annualCheck', 'annualMonthCheck', 'annualYearCheck'],
        roleOverride: 1,
        isSpecialAdmin: true
      },
    }
  },

  mutations: {
    setToken(state, token) {
      state.token = token
    },

    setRoleId(state, roleId) {
      state.roleId = roleId
    },

    setAccount(state, account) {
      state.account = account
    },

    clearLoginData(state) {
      state.token = null
      state.roleId = null
      state.account = null
      sessionStorage.removeItem('encrypted_auth_data')
    },

    // 從加密的 sessionStorage 載入資料
    loadEncryptedData(state) {
      const encryptedData = sessionStorage.getItem('encrypted_auth_data')
      if (encryptedData) {
        const decryptedData = decrypt(encryptedData)
        if (decryptedData) {
          state.token = decryptedData.token
          state.roleId = decryptedData.roleId
          state.account = decryptedData.account
        }
      }
    }
  },

  getters: {
    getRoleId: (state) => {
      const specialConfig = state.permissionConfig[state.account]
      return specialConfig?.roleOverride ? specialConfig.roleOverride : Number(state.roleId)
    },

    getAccount: (state) => state.account,

    isSpecialAdmin: (state) => {
      return state.permissionConfig[state.account]?.isSpecialAdmin || false
    },

    canViewMenuItem: (state, getters) => (menuItem) => {
      const account = getters.getAccount
      const specialConfig = state.permissionConfig[account]
      const roleId = getters.getRoleId

      const commonFeatures = ['download', 'changePassword']
      if (commonFeatures.includes(menuItem)) {
        return true
      }

      if (account === 'fenderdog9482@gmail.com') {
        const adminFeatures = [
          'checkEmployee',
          'annualCheck',
          'annualMonthCheck'
        ]
        if (adminFeatures.includes(menuItem)) {
          return true
        }
      }

      if (menuItem === 'testPage') {
        return account === 'fenderdog9482@gmail.com'
      }


      const employeeFeatures = ['clockIn', 'clockInRecord', 'employeeInfo', 'leave', 'AnnualToCash', 'QueryClockIn']
      const adminFeatures = ['checkEmployee', 'annualCheck', 'annualMonthCheck', 'CompensatoryChange']

      if (roleId === 2 && employeeFeatures.includes(menuItem)) {
        return true
      }

      if (roleId === 4 && employeeFeatures.includes(menuItem)) {
        return true;
      }

      if (roleId === 1 && adminFeatures.includes(menuItem)) {
        return true
      }


      if (specialConfig) {
        if (specialConfig.extraMenus && specialConfig.extraMenus.includes(menuItem)) {
          return true
        }
        // 客製化特殊帳號的原始權限
        if (specialConfig.keepOriginalRole) {
          const originalRoleFeatures = roleId === 1 ? adminFeatures :
            roleId === 2 ? employeeFeatures : []
          if (originalRoleFeatures.includes(menuItem)) {
            return true
          }
        }
      }

      return false
    }
  },

  actions: {
    saveLoginData({ commit }, { token, roleId, account }) {
      commit('setToken', token)
      commit('setRoleId', roleId)
      commit('setAccount', account)

      // 將資料加密後儲存在 sessionStorage
      const dataToEncrypt = { token, roleId, account }
      const encryptedData = encrypt(dataToEncrypt)
      sessionStorage.setItem('encrypted_auth_data', encryptedData)

      if (account && this.state.permissionConfig[account]) {
        console.log('Special account logged in:', account)
      }
    },

    logout({ commit }) {
      commit('clearLoginData')
    },

    // 初始化時載入加密資料
    initializeStore({ commit }) {
      commit('loadEncryptedData')
    }
  }
})
